import { HowToMeasure1 } from '../how-to-measure-1';
import { HowToMeasure2 } from '../how-to-measure-2';
import { KidsBibsAndCoveralls } from './bibs-and-coveralls';
import { KidsBoots } from './boots';
import { KidsWader } from './neoprene-waders';
import { KidsPvcWader } from './pvc-waders';

export const Kid = () => {
  return (
    <div className='mx-auto w-full max-w-[1400px]  px-[16px] lg_px-0'>
      <KidsBoots />
      <KidsWader></KidsWader>
      <KidsPvcWader></KidsPvcWader>
      <KidsBibsAndCoveralls></KidsBibsAndCoveralls>

      <HowToMeasure1 />
      <HowToMeasure2 image='/contact-us/kid-measure.png' />
    </div>
  );
};
